import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Arrow3Svg from '../icons/Arrow3Svg'

export class Card8 extends Component {
    render() {
        return (
            <div className='w-full flex justify-between items-center bg-[#f4f8fc] p-[28px] rounded-[24px] max-[1080px]:flex-col max-[1080px]:gap-[16px] max-[1080px]:items-start' >

                <div className='flex items-center gap-[8px] w-[330px] max-[500px]:w-full'>
                    <div className='p-[4px] border-[1px] rounded-[50%] bg-[#0E38B1] border-[#0E38B1]'>
                        {this.props.icon}
                    </div>
                    <div>
                        <h3 className='font-[500] text-[19px] max-[400px]:text-[17px]'>{this.props.title}</h3>
                    </div>
                </div>

                <div className='max-w-[500px] text-center max-[1080px]:text-start '>
                    <p className='text-[16px] font-[500] max-[400px]:text-[15px]'>{this.props.text}</p>
                </div>

                <Link to={`/blogs/${this.props.path}`} className='text-[#fff] bg-[#0E38B1] p-[6px_14px] rounded-[8px] flex items-center gap-[4px]'>
                    <span className=' max-[400px]:text-[15px]  max-[1080px]:w-full '>Daha ətraflı</span> <Arrow3Svg className="stroke-[#fff]" />
                </Link>
            </div>
        )
    }
}

export default Card8